import { mergeDeep } from "../../../utils/Helper";
import { Mode } from "../../Asset/types";

export const defaultState = () => ({
  dialogMode: Mode.Insert,
  globalError: null,
  custodianEntityId: 0,
  custodianEntity: [],
  custody: {
    name: "",
    entityId: 0,
    custodiesCash: false,
    custodiesValues: false,
    description: "",
    feeSchema: "",
    currencyId: 0,
    isProp: false,
    isLocalBank: false,
    currencyAccounts: [],
    clearingHouse: [],
    accountType: 1,
    CustodianMoneyMarketRate: 0,
    CustodianMarginRate: 0,
    CustodianRelatedAccountId: 0,
    CustodianMoneyMarketRateMin: 0,
  },
  clearingHouseItem: {
    clearingHouseId: 0,
    clearingHouseSettlementInstructions: "",
    clearingHouseDefault: false,
    clearingHouseCode: "",
    name: "",
  },
  fields: {
    readonly: {},
    errors: {},
  },
  buttons: {
    confirm: {
      loading: false,
    },
  },
  editClearingHouse: false,
  editClearingHouseId: false,
  saveEditClearingHouseId: 0,
  saveEditClearingHouseCode: 0,
  initialized: true,
  buttons: {
    confirm: {
      loading: false,
    },
  },
  error: true,
  errors: {
    name: false,
    currencyNumber: false,
    feeSchema: false,
    description: false,
    CustodianMoneyMarketRate: false,
    CustodianMarginRate: false,
    CustodianRelatedAccountId: false,
    CustodianMoneyMarketRateMin: false,
    custodianEntityId: false,
  },
  message: "",
  sentAuthorization: false,
  openCustodianEntity: false,
  Countries: [],
  isEditCustodianEntity: false,
});

export const CustodySimpleReducer = (state, action) => {
  switch (action.type) {
    case "LOAD_FOR_EDIT_CUSTODY":
      return processLoadForEditCustody(state, action.fields);
    case "CHANGE_DIALOG_MODE":
      return processChangeDialogMode(state, action.nextMode);
    case "CHANGE_FIELDS":
      return processChangeFields(state, action.fields);
    case "UPDATE_FIELDS":
      return processFields(state, action);
    case "EDIT_CLEARING_HOUSE":
      return editClearingHouse(state, action);
    case "CLEARING_HOUSES_FIELDS":
      return processChangeClearingHousesFields(state, action.fields);
    case "CLOSE_CLEARING_HOUSE":
      return closeClearingHouse(state);
    case "ADD_CLEARING_HOUSE":
      return AddClearingHouses(state, action);
    case "EDIT_CLEARING_HOUSE_ID":
      return EditClearingHouseId(state, action);
    case "SAVE_EDIT_CLEARING_HOUSE":
      return SaveEditClearingHouse(state, action);
    case "INITIALIZE_VALUES":
      return InitializeValues(state, action);
    case "CHANGE_FIELDS_ACCOUNT_TYPE":
      return ChangeAccountType(state, action.fields);
    case "UPDATE_BUTTONS":
      return processUpdateButtons(state, action.buttons);
    case "VALIDATE_FIELDS":
      return validateForm(state);
    case "SENT_AUTHORIZATION":
      return SentAuthorization(state, action);
    case "RESET_CLOSE":
      return ResetClose(state, action);
    case "OPEN_CUSTODIAN_ENTITY":
      return OpenCustodianEntity(state, action);
    case "CLOSE_CUSTODIAN_ENTITY":
      return CloseCustodianEntity(state, action);
    case "SET_COUNTRIES":
      return SetCountries(state, action);
    case "EDIT_CUSTODIAN_ENTITY":
      return EditCustodianEntity(state, action);
    case "RECHARGE_CUSTODIAN_ENTITY":
      return RechargeCustodianEntity(state, action);
    case "GET_CUSTODIAN_ENTITY":
      return GetCustodianEntity(state, action);
    default:
      return state;
  }
};

export const initialize = (props) => {
  return (initialState) => {
    return {
      ...initialState,
    };
  };
};

export function editClearingHouse(state, props) {
  const { editClearingHouse, counterparty } = state;
  return mergeDeep(
    { ...state },
    {
      editClearingHouse: true,
      editClearingHouseId: false,
      clearingHouseItem: {
        clearingHouseCode: 0,
        name: props.clearingHouses[0].name,
        clearingHouseId: props.clearingHouses[0].id,
        clearingHouseSettlementInstructions: "",
        clearingHouseDefault: false,
      },
    }
  );
}

function processChangeDialogMode(state, nextMode) {
  return mergeDeep(
    { ...state },
    {
      initialized: false,
      dialogMode: nextMode,
    }
  );
}

function processLoadForEditCustody(state, fields) {
  const { entityId, ...props } = fields;
  const accountType = props.isProp ? 2 : 1;
  const currencyImputableAccount =
    props.currencyImputableAccount === "0" ? null : props.currencyImputableAccount;
  return mergeDeep(
    { ...state },
    {
      initialized: true,
      custodianEntityId: entityId,
      custody: {
        ...state.custody,
        ...props,
        accountType,
        currencyImputableAccount,
        rateRanges: fields.rateRanges || [],
      },
    }
  );
}

function processChangeClearingHousesFields(state, fields) {
  const errors = Object.keys(fields).reduce((f, name) => {
    f[name] = undefined;
    return f;
  }, {});

  return mergeDeep(
    { ...state },
    {
      clearingHouseItem: {
        ...fields,
      },
      fields: {
        errors,
      },
    }
  );
}

function processFields(state, fields) {
  return mergeDeep(
    { ...state },
    {
      ...fields.fields,
    }
  );
}

function processChangeFields(state, fields) {
  const errors = Object.keys(fields).reduce((f, name) => {
    f[name] = undefined;
    return f;
  }, {});

  return mergeDeep(
    { ...state },
    {
      custody: {
        ...fields,
      },
      errors,
    }
  );
}

function ChangeAccountType(state, fields) {
  var isProp = false;
  if (fields.accountType == 2) {
    isProp = true;
  }
  return mergeDeep(
    { ...state },
    {
      custody: {
        accountType: fields.accountType,
        isProp: isProp,
      },
    }
  );
}

export function closeClearingHouse(state) {
  const { editClearingHouse } = state;
  return mergeDeep(
    { ...state },
    {
      editClearingHouse: false,
      editClearingHouseId: false,
      clearingHouseItem: {
        clearingHouseCode: 0,
        name: "",
        clearingHouseId: 0,
        clearingHouseSettlementInstructions: "",
        clearingHouseDefault: false,
      },
    }
  );
}

export function OpenCustodianEntity(state) {
  const { editClearingHouse } = state;
  return mergeDeep(
    { ...state },
    {
      isEditCustodianEntity: false,
      openCustodianEntity: true,
    }
  );
}

export function CloseCustodianEntity(state) {
  const { editClearingHouse } = state;
  return mergeDeep(
    { ...state },
    {
      openCustodianEntity: false,
    }
  );
}

export function AddClearingHouses(state, action) {
  const { counterparty, fields, clearingHouseItem, clearingHouses, editClearingHouse } = state;
  var name = "";
  for (var j = 0; j < action.clearingHouses.length; j++) {
    if (action.clearingHouses[j].id == clearingHouseItem.clearingHouseId) {
      name = action.clearingHouses[j].name;
    }
  }
  var clearingHouse = {
    clearingHouseId: clearingHouseItem.clearingHouseId,
    clearingHouseSettlementInstructions: clearingHouseItem.clearingHouseSettlementInstructions,
    clearingHouseDefault: clearingHouseItem.clearingHouseDefault,
    clearingHouseCode: clearingHouseItem.clearingHouseCode,
    name: name,
  };
  var custody = {
    ...state.custody,
    clearingHouse: [...state.custody.clearingHouse, clearingHouse],
  };
  return mergeDeep(
    { ...state },
    {
      custody: custody,
      editClearingHouse: false,
      editClearingHouseId: false,
    }
  );
}

function EditClearingHouseId(state, c) {
  var clear = {
    clearingHouseId: 0,
    clearingHouseSettlementInstructions: "",
    clearingHouseDefault: false,
    clearingHouseCode: "",
    name: "",
  };
  for (var i = 0; i < state.custody.clearingHouse.length; i++) {
    if (
      state.custody.clearingHouse[i].clearingHouseId == c.c.clearingHouseId &&
      state.custody.clearingHouse[i].clearingHouseCode == c.c.clearingHouseCode
    ) {
      clear = {
        clearingHouseCode: state.custody.clearingHouse[i].clearingHouseCode,
        name: state.custody.clearingHouse[i].name,
        clearingHouseId: state.custody.clearingHouse[i].clearingHouseId,
        clearingHouseSettlementInstructions:
          state.custody.clearingHouse[i].clearingHouseSettlementInstructions,
        clearingHouseDefault: state.custody.clearingHouse[i].clearingHouseDefault,
      };
    }
  }
  return mergeDeep(
    { ...state },
    {
      editClearingHouseId: true,
      clearingHouseItem: clear,
      saveEditClearingHouseId: c.c.clearingHouseId,
      saveEditClearingHouseCode: c.c.clearingHouseCode,
    }
  );
}

export function SaveEditClearingHouse(state, action) {
  const {
    counterparty,
    fields,
    clearingHouseItem,
    saveEditClearingHouseId,
    saveEditClearingHouseCode,
    errors,
  } = state;
  var name = "";
  var clearing = state.custody.clearingHouse;
  for (var i = 0; i < clearing.length; i++) {
    if (
      clearing[i].clearingHouseId == saveEditClearingHouseId &&
      clearing[i].clearingHouseCode == saveEditClearingHouseCode
    ) {
      for (var j = 0; j < action.clearingHouses.length; j++) {
        if (action.clearingHouses[j].id == clearingHouseItem.clearingHouseId) {
          name = action.clearingHouses[j].name;
        }
      }
      clearing[i] = {
        clearingHouseCode: clearingHouseItem.clearingHouseCode,
        name: name,
        clearingHouseId: clearingHouseItem.clearingHouseId,
        clearingHouseSettlementInstructions: clearingHouseItem.clearingHouseSettlementInstructions,
        clearingHouseDefault: clearingHouseItem.clearingHouseDefault,
      };
    }
  }
  var custody = { ...state.custody, clearingHouse: clearing };
  return mergeDeep(
    { ...state },
    {
      clearingHouses: custody,
      editClearingHouse: false,
      editClearingHouseId: false,
      saveEditClearingHouseId: 0,
      saveEditClearingHouseCode: 0,
    }
  );
}

export function InitializeValues(state, action) {
  const { editClearingHouse } = state;
  var entity = 0;
  var currency = 0;
  var account = 0;
  if (action.custodianEntity.length > 0) {
    entity = action.custodianEntity[0].id;
  }
  if (action.currencies.length > 0) {
    currency = action.currencies[0].currencyId;
  }
  if (action.imputableAccounts.length > 0) {
    account = action.imputableAccounts[0].id;
  }
  return mergeDeep(
    { ...state },
    {
      initialized: false,
      custody: {
        entityId: entity,
        currencyId: currency,
        currencyImputableAccount: account,
      },
    }
  );
}

export function processUpdateButtons(state, buttons) {
  return mergeDeep(
    { ...state },
    {
      buttons,
    }
  );
}

export function validateForm(state) {
  let errors = {};
  if (state.custody.name == "") {
    errors.name = "Required field";
  }
  if (state.custody.description == "") {
    errors.description = "Required field";
  }
  if (state.custody.CustodianMoneyMarketRate < 0) {
    errors.CustodianMoneyMarketRate = "Must be a positive number";
  }
  if (state.custody.CustodianMarginRate < 0) {
    errors.CustodianMarginRate = "Must be a positive number";
  }
  if (state.custody.CustodianMoneyMarketRateMin < 0) {
    errors.CustodianMoneyMarketRateMin = "Must be a positive number";
  }
  if (state.custody.CustodianRelatedAccountId == 0) {
    errors.CustodianRelatedAccountId = "Required field";
  }
  if (state.custody.custodianEntityId == 0) {
    errors.custodianEntityId = "Required field";
  }
  // if (state.custody.feeSchema == "") {
  //  errors.feeSchema = 'Required field';
  // }
  // if (state.custody.currencyNumber == "") {
  //  errors.currencyNumber = 'Required field';
  // }

  return mergeDeep(
    { ...state },
    {
      errors: errors,
    }
  );
}

export function validateErr(state, isFundManagerSistem) {
  var error = "";
  if (state.custody.name == "") {
    error = "You must enter a name";
  }
  if (state.custody.description == "") {
    error = "You must enter a description";
  }
  if (state.custody.CustodianMoneyMarketRate < 0 && isFundManagerSistem) {
    error = "You must enter a positive number for Custodian Money Market Rate";
  }
  if (state.custody.CustodianMarginRate < 0 && isFundManagerSistem) {
    error = "You must enter a positive number for Custodian Margin Rate";
  }
  if (state.custody.CustodianMoneyMarketRateMin < 0 && isFundManagerSistem) {
    error = "You must enter a positive number for Custodian Money Market Rate Min";
  }
  if (state.custody.CustodianRelatedAccountId == 0 && isFundManagerSistem) {
    error = "You must select a Custodian Related Account";
  }
  if (state.custody.custodianEntityId == 0) {
    error = "You must select a Custodian Entity";
  }
  // if (state.custody.feeSchema == "") {
  //   error = true;
  // }
  // if (state.custody.currencyNumber == "") {
  //   error = true;
  // }
  return error;
}

export function SentAuthorization(state, response) {
  var message = "";
  if (response.response.result.Code == 200) {
    message = "Custody sent for authorization";
  } else {
    message = response.response.result.Description;
  }
  var button = {
    confirm: {
      loading: false,
    },
  };
  return mergeDeep(
    { ...state },
    {
      sentAuthorization: true,
      buttons: button,
      message: message,
    }
  );
}

export function ResetClose(state, action) {
  action.onClickClose();
  return mergeDeep(
    { ...state },
    {
      dialogMode: Mode.Insert,
      globalError: null,
      custody: {
        name: "",
        entityId: 0,
        custodiesCash: false,
        custodiesValues: false,
        description: "",
        feeSchema: "",
        currencyId: 0,
        isProp: false,
        currencyNumber: "",
        currencyImputableAccount: 0,
        isLocalBank: false,
        clearingHouse: [],
        accountType: 1,
        CustodianMoneyMarketRate: 0,
        CustodianMarginRate: 0,
        CustodianRelatedAccountId: 0,
        CustodianMoneyMarketRateMin: 0,
      },
      clearingHouseItem: {
        clearingHouseId: 0,
        clearingHouseSettlementInstructions: "",
        clearingHouseDefault: false,
        clearingHouseCode: "",
        name: "",
      },
      fields: {
        readonly: {},
        errors: {},
      },
      buttons: {
        confirm: {
          loading: false,
        },
      },
      editClearingHouse: false,
      editClearingHouseId: false,
      saveEditClearingHouseId: 0,
      saveEditClearingHouseCode: 0,
      initialized: true,
      buttons: {
        confirm: {
          loading: false,
        },
      },
      error: true,
      errors: {
        name: false,
        currencyNumber: false,
        feeSchema: false,
        description: false,
        CustodianMoneyMarketRate: false,
        CustodianMarginRate: false,
        CustodianRelatedAccountId: false,
        CustodianMoneyMarketRateMin: false,
        custodianEntityId: false,
      },
      message: "",
      sentAuthorization: false,
    }
  );
}

function SetCountries(state, action) {
  return mergeDeep(
    { ...state },
    {
      Countries: action.response.countries,
    }
  );
}

function EditCustodianEntity(state, action) {
  return mergeDeep(
    { ...state },
    {
      isEditCustodianEntity: true,
      openCustodianEntity: true,
    }
  );
}

export function RechargeCustodianEntity(state, action) {
  return mergeDeep(
    { ...state },
    {
      custodianEntity: action.response.custodianEntity,
      custodianEntityId: action.id,
    }
  );
}

export function GetCustodianEntity(state, action) {
  var id = 0;
  if (action.response.custodianEntity.length > 0) {
    id = action.response.custodianEntity[0].id;
  }
  return mergeDeep(
    { ...state },
    {
      custodianEntity: action.response.custodianEntity,
      custodianEntityId: id,
    }
  );
}
